export const bags = {
    LAST_CATCH: 'lastcatch',
    CATCHERS: 'catchers',
    PROFILE: 'profile',
};
export const localStorage = {
    VERSION: 1,
    save(bag, item) {
        window.localStorage.setItem(this.getKey(bag), JSON.stringify(item));
    },
    load(bag) {
        return JSON.parse(window.localStorage.getItem(this.getKey(bag)));
    },
    clear() {
        window.localStorage.clear();
    },
    getKey(bag) {
        return `${bag}-${this.VERSION}`;
    },
};
